import React from 'react'
import { observer } from 'mobx-react-lite'

import { makeStyles } from '@material-ui/core/styles'

import { Box } from '@material-ui/core'

import { MyProductsColumnCheckbox } from './MyProductsColumnCheckbox'

import { useMyProductColumns } from '../hooks/myProductHooks'

import { MyProductColumnGroupId, myProductColumnGroupNames } from '../types/myProductColumnGroups'

export const MyProductsColumnItem =
  observer(
    ({groupId}: {groupId: MyProductColumnGroupId}) => {
      const classes = useStyles()

      const myProductColumns = useMyProductColumns()

      const columnGroup = myProductColumns.grouped[groupId]

      return (
        <>
          <Box>
            <Box marginLeft={1} style={{marginBottom: 12}}>
              <span className={classes.dash}>—</span>
              <span className={classes.label}>{myProductColumnGroupNames[groupId]}</span>
            </Box>

            {
              columnGroup.filter(column => column.id !== 'Select')
                         .map(column => <MyProductsColumnCheckbox key={column.id} column={column}/>)
            }
          </Box>

        </>
      )
    })

const useStyles = makeStyles(
  (theme) => ({
    dash: {
      color: '#3987CF'
    },
    label: {
      fontSize: 14,
      color: theme.palette.mpSkladPrimary.gray,
      marginLeft: 5
    }
  }))